import { render, staticRenderFns } from "./Isim.vue?vue&type=template&id=16ce9390"
import script from "./Isim.vue?vue&type=script&lang=js"
export * from "./Isim.vue?vue&type=script&lang=js"
import style0 from "./Isim.vue?vue&type=style&index=0&id=16ce9390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports